module.exports = __webpack_public_path__ + "img/charity.4d5d1e32.svg";